import { useState, useEffect } from 'react';
import styled from 'styled-components';
import Lottie from 'lottie-react';
import moment from 'moment';

// Model //
import AttendanceRankingMemberList from './AttendanceRankingMemberList';
import WeeklyAbsenteeMemberList from './WeeklyAbsenteeMemberList';
import CalculationFomulaModal from './CalculationFormulaModal';
// Model //

// Animation // 
import LoadingAnimation from '../../../Animation/LoadingAnimation.json';
// Animation // 

// Image //
import NotAvailableRightArrow from '../../../image/NotAvailableRight.png';
import NotAvailableLeftArrow from '../../../image/NotAvailableLeft.png';
import Attendance1ImagePath from '../../../image/Attendance1.png';
import Attendance2ImagePath from '../../../image/Attendance2.png';
import RightArrow from '../../../image/Right.png'
import LeftArrow from '../../../image/Left.png'
// Image //


export default function MemberAttendanceBox(props) {
  const {
    today,
    startDate,
    endDate,
    calcDateText,

    attendanceTotal,
    attendanceRanking,
    totalMonthAttendanceCount,

    selectedPartnerGym,
    isOpenPartnerGymSales,
    isWeekAttendanceLoading, 
    setIsWeekAttendanceLoading,
    isMonthAttendanceLoading,
  } = props;

  const [weeklyDate, setWeeklyDate] = useState([]);
  const [weeklyIndex, setWeeklyIndex] = useState(0);
  const [weeklyValidMemberCount, setWeeklyValidMemberCount] = useState(0);
  const [weeklyAttendanceCount, setWeeklyAttendanceCount] = useState(0);
  const [absentee, setAbsentee] = useState([]);

  const [isViewWeeklyAttendanceRateModal, setIsViewWeeklyAttendanceRateModal] = useState(false);
  const [isViewMonthlyAttendanceRateModal, setIsViewMonthlyAttendanceRateModal] = useState(false);

  // 매 주차 첫번째날 뽑기 //
  useEffect(() => {
    let start = moment(today.format('YYYY-MM-') + '01T00:00:00');
    let end = moment(start).add(1, 'month').subtract(1, 'second');

    if (!moment().isAfter(end)) end = moment(moment().format('YYYY-MM-DDT23:59:59'));

    if (startDate.format('YYYY-MM-DDTHH:mm:ss') === start.format('YYYY-MM-DDTHH:mm:ss')
      && endDate.format('YYYY-MM-DDTHH:mm:ss') === end.format('YYYY-MM-DDTHH:mm:ss')) {
      let newList = [];

      newList.push(startDate.clone());

      let nextStandardDate = startDate.clone().add(7, 'days');

      while (true) {
        if (startDate.clone().format('MM') === nextStandardDate.clone().format('MM')) {
          newList.push(nextStandardDate.clone());
          nextStandardDate.add(7, 'days');
        }
        else break;
      }

      let newCompleteList = [];

      for (let i = 0; i < newList.length; i++) {
        for (let j = 0; j < 7; j++) {
          if (newList[i].clone().subtract(j, 'day').format('dd') === 'Mo') {

            let data = {
              startDate: newList[i].clone().subtract(j, 'day'),
              endDate: newList[i].clone().subtract(j, 'day').add(7, 'days').subtract(1, 'seconds')
            };

            newCompleteList.push(data);
            break;
          }
        }
      }

      setWeeklyDate(newCompleteList);
    }
    else {
      let data = {
        startDate: startDate,
        endDate: endDate
      }

      setWeeklyDate([data]);
    }
  }, [startDate, endDate])

  // 선택된 주간 마다 데이터 변경 //
  useEffect(() => {
    if (weeklyDate.length === 0) return;

    let isLastest = true;

    let validMemberCount = 0;
    let attendanceCount = 0;
    let absentee = [];
    
    if (weeklyDate[weeklyIndex].startDate.isBefore(moment())) {
      // 주간 유효회원중 출석한 회원 고르기 //
      for (let i = 0; i < attendanceTotal.length; i++) {
        // 주간에 유효회원인지 확인 //
        if (moment(attendanceTotal[i].endDate).isAfter(weeklyDate[weeklyIndex].endDate)
          || moment(attendanceTotal[i].endDate).isSame(weeklyDate[weeklyIndex].endDate)) {
          validMemberCount += 1;
          let isExist = false;

          for (let j = 0; j < attendanceTotal[i].reserveAttendances.length; j++) {
            if ((moment(attendanceTotal[i].reserveAttendances[j].classDate).isAfter(weeklyDate[weeklyIndex].startDate)
              || moment(attendanceTotal[i].reserveAttendances[j].classDate).isSame(weeklyDate[weeklyIndex].startDate))
              && (moment(attendanceTotal[i].reserveAttendances[j].classDate).isBefore(weeklyDate[weeklyIndex].endDate))) {
              isExist = true;
              break;
            }
          }

          if (!isExist) {
            absentee.push(attendanceTotal[i]);
          }
          else attendanceCount += 1;
        }
      }
    }

    if (isLastest) {
      setWeeklyValidMemberCount(validMemberCount);
      setAbsentee(absentee);
      setWeeklyAttendanceCount(attendanceCount);

      setTimeout(() => {
        setIsWeekAttendanceLoading(false);
      }, 500)
    }

    return () => {
      isLastest = false;
    }
  }, [isWeekAttendanceLoading, attendanceTotal, weeklyDate, weeklyIndex])

  // 주간 출석율 호버링시 //
  function onMouseOverWeeklyAttendanceRate() {
    setIsViewWeeklyAttendanceRateModal(true);
  }

  // 주간 출석율 호버링시 //
  function onMouseLeaveWeeklyAttendanceRate() {
    setIsViewWeeklyAttendanceRateModal(false);
  }

  // 월간 출석율 호버링시 //
  function onMouseOverMonthlyAttendanceRate() {
    setIsViewMonthlyAttendanceRateModal(true);
  }

  // 월간 출석율 호버링시 //
  function onMouseLeaveMonthlyAttendanceRate() {
    setIsViewMonthlyAttendanceRateModal(false);
  }

  // 주간 출석률 계산 //
  function decideWeeklyAttendanceRate() {
    if (weeklyValidMemberCount === 0 || weeklyAttendanceCount === 0) return 0;
    else return Math.round((weeklyAttendanceCount / weeklyValidMemberCount) * 100);
  }

  // 주간 출석률 계산 //
  function decideWeeklyAttendanceRateView() {
    if (weeklyValidMemberCount === 0) return '미산정';
    else if (weeklyAttendanceCount === 0) return '0%';
    else return decideWeeklyAttendanceRate() + '%';
  }

  // 이전 주차 클릭시 //
  function onClickPrevWeeklyDate() {
    if (weeklyIndex > 0) setWeeklyIndex(weeklyIndex - 1);
  }

  // 다음 주차 클릭시 //
  function onClickNextWeeklyDate() {
    if (weeklyIndex < weeklyDate.length - 1) setWeeklyIndex(weeklyIndex + 1);
  }

  return (
    <TopLevelWrapper>
      <InfoBox>
        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#232323' cursor='default'>{calcDateText() + ' 주간 출석 현황'}</Text>
        {
          isWeekAttendanceLoading ?
            <AnimationBox>
              <LottieWrapper>
                <Lottie animationData={LoadingAnimation} loop={true} />
              </LottieWrapper>
            </AnimationBox>
            :
            <InnerInfoBox>
              {
                isOpenPartnerGymSales ?
                  <InfoView>
                    <TopUIWrapper>
                      <WeekAttendanceIcon src={Attendance1ImagePath} />
                      <WeekAttendancePersent onMouseOver={onMouseOverWeeklyAttendanceRate} onMouseLeave={onMouseLeaveWeeklyAttendanceRate}>
                        <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#FFFFFF' cursor='pointer'>주간 출석률</Text>
                        <Text fontFamily='NotoSansKR-Bold' fontSize={14} color='#FFFFFF' cursor='pointer'>{decideWeeklyAttendanceRateView()}</Text>
                      </WeekAttendancePersent>
                      <CalculationFomulaModal 
                        isView={isViewWeeklyAttendanceRateModal}
                        denominator={weeklyAttendanceCount.toLocaleString('ko-KR')}
                        denominatorText='(주간 회원 총 출석 횟수)'
                        numerator={weeklyValidMemberCount.toLocaleString('ko-KR')}
                        numeratorText='(주간 총 유효회원)'
                        result={decideWeeklyAttendanceRate()}
                        resultUnit='%'
                        innerBoxBackgroundColor='#54AB7D'
                        componentBoxBackgroundColor='#6DD2A6'/>
                      <DivisionLine width={102}/>
                      <ResultBox width={131}>
                        <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#777777' cursor='default'>주간 미출석자</Text>
                        <Text fontFamily='NotoSansKR-Bold' fontSize={14} color='#777777' cursor='default'>{absentee.length + '명'}</Text>
                      </ResultBox>
                    </TopUIWrapper>
                    <ListTitleWrapper>
                      <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#595959' cursor='default'>주간 미출석자</Text>
                      <WeeklySelectWrapper>
                        <WeeklySelectButton onClick={onClickPrevWeeklyDate}>
                          <WeeklySelectButtonImage src={weeklyIndex === 0 ? NotAvailableLeftArrow : LeftArrow}/>
                        </WeeklySelectButton>
                        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#595959' cursor='default'>{calcDateText() + ' ' + (weeklyDate.length > 1 ? ((weeklyIndex + 1) + '주차') : '')}</Text>
                        <WeeklySelectButton onClick={onClickNextWeeklyDate}>
                          <WeeklySelectButtonImage src={weeklyIndex === weeklyDate.length - 1 ? NotAvailableRightArrow : RightArrow}/>
                        </WeeklySelectButton>
                      </WeeklySelectWrapper>
                    </ListTitleWrapper>
                    <WeeklyAbsenteeMemberList data={absentee} selectedPartnerGym={selectedPartnerGym}/>
                  </InfoView>
                  :
                  <NotOpenTextWrapper>
                    <Text fontFamily='NotoSansKR-Bold' fontSize={15} color='#444444' cursor='default'>이 업체는 파트너 체육관에 매출을 비공개 합니다</Text>
                    <Text fontFamily='NotoSansKR-Regular' fontSize={15} color='#444444' cursor='default'>링크존 설정에서 “파트너 체육관”에서 권한 설정해 주세요</Text>
                  </NotOpenTextWrapper>
              }
            </InnerInfoBox>
        }
      </InfoBox>

      <BoxDivisionLine />

      <InfoBox>
        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#232323' cursor='default'>{calcDateText() + ' 월간 출석 현황'}</Text>
        {
          isMonthAttendanceLoading ?
            <AnimationBox>
              <LottieWrapper>
                <Lottie animationData={LoadingAnimation} loop={true} />
              </LottieWrapper>
            </AnimationBox>
            :
            <InnerInfoBox>
              {
                isOpenPartnerGymSales ?
                  <InfoView>
                    <TopUIWrapper>
                      <WeekAttendanceIcon src={Attendance2ImagePath} />
                      <MonthAverageAttendancePersent onMouseOver={onMouseOverMonthlyAttendanceRate} onMouseLeave={onMouseLeaveMonthlyAttendanceRate}>
                        <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#FFFFFF' cursor='pointer'>월간 출석률</Text>
                        <Text fontFamily='NotoSansKR-Bold' fontSize={14} color='#FFFFFF' cursor='pointer'>{Math.round((totalMonthAttendanceCount / attendanceRanking.length) * 100)}%</Text>
                      </MonthAverageAttendancePersent>
                      <CalculationFomulaModal 
                        isView={isViewMonthlyAttendanceRateModal}
                        denominator={totalMonthAttendanceCount.toLocaleString('ko-KR')}
                        denominatorText='(월간 회원 총 출석 횟수)'
                        numerator={attendanceRanking.length.toLocaleString('ko-KR')}
                        numeratorText='(월간 총 유효회원)'
                        result={Math.round((totalMonthAttendanceCount / attendanceRanking.length) * 100)}
                        resultUnit='%'
                        innerBoxBackgroundColor='#BA7F0B'
                        componentBoxBackgroundColor='#FFA800'/>
                      <DivisionLine width={106}/>
                      <ResultBox width={127}>
                        <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#777777' cursor='default'>월간</Text>
                        <Text fontFamily='NotoSansKR-Bold' fontSize={14} color='#777777' cursor='default'>{totalMonthAttendanceCount}명</Text>
                        <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#777777' cursor='default'>출석</Text>
                      </ResultBox>
                    </TopUIWrapper>
                    <ListTitleWrapper>
                      <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#595959' cursor='default'>월간 출석 순위</Text>
                    </ListTitleWrapper>
                    <AttendanceRankingMemberList data={attendanceRanking} selectedPartnerGym={selectedPartnerGym}/>
                  </InfoView>
                  :
                  <NotOpenTextWrapper>
                    <Text fontFamily='NotoSansKR-Bold' fontSize={15} color='#444444' cursor='default'>이 업체는 파트너 체육관에 매출을 비공개 합니다</Text>
                    <Text fontFamily='NotoSansKR-Regular' fontSize={15} color='#444444' cursor='default'>링크존 설정에서 “파트너 체육관”에서 권한 설정해 주세요</Text>
                  </NotOpenTextWrapper>
              }
            </InnerInfoBox>
        }
      </InfoBox>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  margin-top: 38px;

  width: 1020px;
  height: 448px;

  gap: 28px;

  border-radius: 30px;
  box-shadow: 0 40px 50px rgba(240, 232, 227, 0.5);
  background-color: #FFFFFF;
`;

const BoxDivisionLine = styled.div`
  diplay: flex;
  flex-direction: row;

  width: 1px;
  height: 392px;

  background-color: #ECECEC;
`;

const InfoBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-conetent: center;
  align-items: flex-start;

  width: 44.5%;
`;

const InnerInfoBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;
  height: 364px;
`;

const InfoView = styled.div`
  display: flex;
  flex-direction: column;

  justify-conetent: center;
  align-items: flex-start;
`;

const AnimationBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  z-index: 5;
  
  width: 100%;
  height: 364px;

  background-color: #FFFFFF;
`;

const LottieWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 80px;
  height: 80px;
`;

const TopUIWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  margin-top: 24px;
`;

const WeekAttendanceIcon = styled.img`
  width: 48px;
  height: 48px;

  margin-right: 8px;
`;

const WeekAttendancePersent = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 133px;
  height: 28px;

  gap: 3px;

  border-radius: 8px;
  background-color: #6DD2A6;

  &:hover {
    cursor: pointer;
  }
`;

const MonthAverageAttendancePersent = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 133px;
  height: 28px;

  border-radius: 8px;
  background-color: #FFA800;

  &:hover {
    cursor: pointer;
  }
`;

const DivisionLine = styled.div`
  display: flex;
  flex-direction: row;

  width: ${props => props.width}px;
  height: 1px;

  margin: 0 16px 0 16px;
  border: 1px solid #ECECEC;
`;

const ResultBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: ${props => props.width}px;
  height: 28px;

  gap: 3px;

  border-radius: 8px;
  background-color: #ECECEC;
`;

const ListTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  margin-top: 24px;

  width: 100%;
`;

const WeeklySelectWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 8px;
`;

const WeeklySelectButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 16px;
  height: 16px;

  border: 1px solid #DFDFDF;
  border-radius: 17px;

  background-color: #FFFFFF;

  &:hover {
    cursor: pointer;
  }
`;

const WeeklySelectButtonImage = styled.img`
  width: 10px;
  height: 10px;

  object-fit: contain;

  &:hover {
    cursor: pointer;
  }
`;

const NotOpenTextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  &:hover {
    cursor: ${props => props.cursor};
  }
`;